import React, {useState, useEffect} from 'react';
import moment from 'moment';
import { PrimaryButton, Modal } from 'wf-react-component-library';
import currencyFormatter from '../utilities/currency-formatter';
import { getItemsByItemCodes } from '../api/p3/ItemApi';
import appConfig from '../configuration/AppConfig';

import './ItemDetailsModal.scss';
import edit from '../icons/edit.svg';

const ItemDetailsModal = (props) =>  {
  
  const editItem = () => {
    props.closeModal();
    props.editItem(props.selectedItem);
  }

  const { selectedItem } = props;

  const dt = moment(selectedItem.modifiedDate);
  const cost = selectedItem.cost ? currencyFormatter.format(selectedItem.cost) : null;
  const deliveredCost = 'deliveredCost' in selectedItem ? currencyFormatter.format(selectedItem.deliveredCost) : null;

  selectedItem.isNotBurdenFreightItem = getItemsByItemCodes(selectedItem.itemId).then((itemDetails) => {
    const selectedItemGroup = itemDetails.length > 0 ? itemDetails[0].itemGroupCode : "";
    return (selectedItemGroup !== "" && selectedItemGroup !== "M" && selectedItemGroup !== "SB" && selectedItemGroup !== "MB");
  });

  return (
    <Modal show={props.showItemDetails} width="75%">
      <div className="flex-container-row item-details-container show">
        <div className="flex-container-row top-level justify-end">
          <div className="flex-container-column">
            <div className="flex-container-row wf-form-element-container">
              <div className="wf-form-element-label">Last Updated By:</div>
              <div className="body-short-form">{selectedItem.modifiedBy}</div>
            </div>
            <div className="flex-container-row wf-form-element-container">
              <div className="wf-form-element-label">Last Updated On:</div>
              <div className="body-short-form">{dt.format('MM/DD/YYYY')}</div>
            </div>
          </div>
        </div>

        <div className="flex-container-row row-details">
          <div className="flex-container-row top-level">
            <div className="headline-small fixed-divider">
              {`Item Details for ${selectedItem.itemId}-${selectedItem.description}`}      
            </div>
            <button data-testid="edit-customers" type="button" name="Edit" className="primary-button icon" onClick={editItem}><img className="edit-icon" src={edit} alt="Edit button" /></button>
          </div>

          { !selectedItem?.isBurdenItem
           ? <div className="flex-container-row top-level">
            <div className="flex-container-column">
              <div className="flex-container-row wf-form-element-container">
                <div className="wf-form-element-label">Item Number:</div>
                <div className="body-short-form">{selectedItem.itemId}</div>
              </div>

              <div className="flex-container-row wf-form-element-container">
                <div className="wf-form-element-label">Vendor Cost:</div>
                <div className="body-short-form">{cost}</div>
              </div>

              <div className="flex-container-row wf-form-element-container">
                <div className="wf-form-element-label">Delivered Cost:</div>
                <div className="body-short-form">{deliveredCost}</div>
              </div>

              <div className="flex-container-row wf-form-element-container">
                <div className="wf-form-element-label">Location:</div>
                <div className="body-short-form">{selectedItem.location}</div>
              </div>

              { appConfig.PREMIUM_FEATURE_ACTIVE === "true" && selectedItem.premium && 'value' in selectedItem.premium
                ? <div className="flex-container-row wf-form-element-container">
                  <div className="wf-form-element-label">Premium:</div>
                  <div className="body-short-form">{`${selectedItem.premium.itemCode} - ${selectedItem.premium.description}: ${selectedItem.premium.value}/${selectedItem.premium.unitType}`}</div>
                </div>
                : null
              }        
            </div>

            <div className="flex-container-column">
              <div className="flex-container-row wf-form-element-container">
                <div className="wf-form-element-label">Description:</div>
                <div className="body-short-form">{selectedItem.description}</div>
              </div>

              <div className="flex-container-row wf-form-element-container vendor-threshholds">
                <div className="wf-form-element-label">Item Ti:</div>
                <div className="body-short-form">{selectedItem.ti}</div>

                <div className="wf-form-element-label">Item Hi:</div>
                <div className="body-short-form">{selectedItem.hi}</div>
              </div>

              <div className="flex-container-row wf-form-element-container">
                <div className="wf-form-element-label">Cooler:</div>
                <div className="body-short-form">{selectedItem.cooler}</div>
              </div>

              <div className="flex-container-row wf-form-element-container">
                <div className="wf-form-element-label">Country of Origin:</div>
                <div className="body-short-form">{selectedItem.countryOfOrigin}</div>
              </div>
            </div>

            <div className="flex-container-column">
              <div className="flex-container-row wf-form-element-container">
                <div className="wf-form-element-label">GTIN:</div>
                <div className="body-short-form">{selectedItem.gtin}</div>
              </div>

              <div className="flex-container-row wf-form-element-container">
                <div className="wf-form-element-label">UPC:</div>
                <div className="body-short-form">{selectedItem.upc}</div>
              </div>

              <div className="flex-container-row wf-form-element-container">
                <div className="wf-form-element-label">PLU:</div>
                <div className="body-short-form">{selectedItem.plu}</div>
              </div>

              { selectedItem.isBurdenFreightItem
                ? <div className="flex-container-row wf-form-element-container">
                    <div className="wf-form-element-label">Unit Type:</div>
                    <div className="body-short-form">{selectedItem.unitType}</div>
                  </div>
                : null
              }
            </div>
          </div>
          : null
          }

          { selectedItem?.isBurdenItem
           ? <div className="flex-container-row top-level">
              <div className="flex-container-column">
                <div className="flex-container-row wf-form-element-container">
                  <div className="wf-form-element-label">Item Number:</div>
                  <div className="body-short-form">{selectedItem.itemId}</div>
                </div>

                <div className="flex-container-row wf-form-element-container">
                  <div className="wf-form-element-label">Vendor Cost:</div>
                  <div className="body-short-form">{cost}</div>
                </div>

                <div className="flex-container-row wf-form-element-container">
                  <div className="wf-form-element-label">Unit Type:</div>
                  <div className="body-short-form">{selectedItem.unitType}</div>
                </div>
              </div> 
            </div>
            : null
          }

        </div>

        <div className="flex-container-row buttons">
          <PrimaryButton onClick={props.closeModal} name="Close" />
        </div>
      </div>
    </Modal>
  );
}

export default ItemDetailsModal;
